function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MoreHoriz } from "sprout-ui-icons";
import { Menu, MenuTitle, MenuItem, MenuTrigger } from "@sprout/list-navigation/dist/Menu";
import TopicPageSectionSectionButton from "./TopicPageSectionSectionButton";
const TopicPageSectionMenu = (props)=>{
    const { section , menuState  } = props;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                children: /*#__PURE__*/ _jsx(TopicPageSectionSectionButton, {
                    children: /*#__PURE__*/ _jsx(MoreHoriz, {})
                })
            })),
            /*#__PURE__*/ _jsxs(Menu, _objectSpread({}, menuState, {
                children: [
                    /*#__PURE__*/ _jsx(MenuTitle, {
                        children: "Branch Options"
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        action: "EDIT_TOPIC",
                        activeItem: section
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        action: "MOVE",
                        activeItem: section
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        action: "ARCHIVE",
                        activeItem: section
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        action: "DELETE",
                        activeItem: section
                    })
                ]
            }))
        ]
    });
};
export default TopicPageSectionMenu;
